import React, { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import api from '../../api/api';
import dollarImage from '../../../src/assets/Signin/Dollar.svg';
import { useNavigate } from 'react-router-dom';
import ToastMessage from '../../utils/mui/righttoptoast';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import cancelledDesk from '../../../src/assets/Signin/FrontCancel.svg';
import ConfirmFrontdesk from './ConfirmFrontdesk';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import lap from '../../assets/Signin/lap.svg'
import InsurancePlansModal from '../../landingscreen/modals/insuranceplanmodal';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '../../reduxtoolkit/toastslice';
import { Backdrop, CircularProgress } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { getPracticeId, practiceFeatures } from '../../config/practice';
import {
  osaPaymentTotal,
  osaCoinsuranceAmount,
  putOsaPaymentUpdate,
  isPaymentRowFor,
  PAYMENT_ROW_NOT_LOADED,
} from '../../landingscreen/modals/osaPayments';
const Payments = ({ isOpen,flow='', ClosePaymentModal, data,updatedata=()=>{},  alldata = [] }) => {
  const [activeTab, setActiveTab] = useState('payment');
  const [PaymentMethod, setPaymentMethod] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [copay, setCopay] = useState(0.0);
    const [showPaymentsHistory, setShowPaymentsHistory] = useState(false);
  const [selfPay, setSelfPay] = useState(0.0);
  const[loader,setLoader]=useState(false)
  const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
const [selectedPlans, setSelectedPlans] = useState([]);
  const[prevamount,setPrevamount]=useState('')
  const [coinsurance, setCoinsurance] = useState(0.0);
  const [deductible, setDeductible] = useState(0.0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0.0);
  const [paymentOnAccount, setPaymentOnAccount] = useState('');
  const [ccnumber, setCcnumber] = useState('');
  const loginUser = localStorage.getItem("user");
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedTab, setSelectedTab] = useState('');

  const [frontdeskModal, setfrontdeskModal] = useState(false);
  const [getpaymentData, setGetpaymentData] = useState(null);
  const [frontDesk, setFrontDesk] = useState('');
  const navigate = useNavigate();
  const practiseid = getPracticeId();
  // 7825: OSA's front-desk payments (landingscreen/modals/osaPayments.js), as
  // in the dashboard Payments popup: the total adds the deductible (and the $
  // coinsurance), the deductible is editable whatever the visit status, no
  // colour options. On the sheet (not the Reports payment edit, flow
  // 'reports') Update saves through v1 update-patient-payments for this visit
  // only, with its coinsurance dollars. 9928 as before.
  const osaPayments = practiceFeatures().osaPayments;
  const osaVisitPayments = osaPayments && flow !== 'reports';
 const userConfig = useSelector((state) => state.userconfig);
  const currentPatient = alldata[currentIndex] || {};
const dispatch=useDispatch()
  useEffect(() => {
    if (isOpen && data && alldata.length > 0) {
      const foundIndex = alldata.findIndex(p => p.patientid === data.patientid);
      setCurrentIndex(foundIndex !== -1 ? foundIndex : 0);
       fetchData()
   

    }
  }, [isOpen, data, alldata,]);
  useEffect(()=>{
    fetchFrontDesk();
if(flow!='reports'){
    fetchprevamount() }
  handleGetPayment({data:currentPatient });
  },[currentPatient])

  const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

function formatDateTime(dateInput, timeInput) {
  if (!dateInput) return "";

  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";

  // Format only the date part
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return `${formattedDate} ${timeInput || ""}`;
}

  const handleGetPayment = async ({ data }) => {
    const dateString = data.startdate;
    setLoader(true)
  
    const formattedDate = new Date(dateString).toLocaleDateString('en-CA');
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${data?.patientid}/view-payments`, {
        appointmentid: data.appointmentid,
        startdate: formattedDate,
      });
      if (response.status === 200) {
        setGetpaymentData(response.data);
      } else if (osaVisitPayments) {
        // 7825: no row for this visit -- never keep showing (or saving)
        // the previous visit's amounts.
        setGetpaymentData(null);
      }
    } catch (error) {
      console.error('Error fetching payment:', error);
      if (osaVisitPayments) setGetpaymentData(null);
    }finally{
      setLoader(false)
    }
  };

  const fetchFrontDesk = async () => {
    try {
      const response = await api.post(`/v1/${practiseid}/appointments/patient/${currentPatient?.patientid}/get_front_desk`, {
        appointmentid: data.appointmentid,
      });
      if (response.status === 200) {
        setFrontDesk(response?.is_front_desk||'');
      }
    } catch (error) {
      console.error('Error fetching front desk:', error);
    }
  };

  const fetchUpdateFrontDesk = async ({ frontDesk, data }) => {
    try {
      const response = await api.put(`/v1/${practiseid}/appointments/patient/${data.patientid}/front_desk`, {
        appointmentid: data.appointmentid,
        is_front_desk: frontDesk,
      });
      if (response.status === 200) {
      fetchFrontDesk();
  handleGetPayment({data:currentPatient });
      }
    } catch (error) {
      console.error('Error updating front desk:', error);
    }
  };

  useEffect(() => {
    if (osaPayments) {
      // OSA: copay + self pay + balance + deductible + coinsurance dollars.
      setTotalAmount(osaPaymentTotal({ copay, selfPay, paymentOnAccount, deductible, coinsurance }));
      return;
    }
    const initialTotal =
      (parseFloat(copay) || 0.0) +
      (parseFloat(selfPay) || 0.0) +
      // (parseFloat(deductible) || 0.0) +
      (parseFloat(paymentOnAccount) || 0.0);
    let totalAfter = initialTotal;
    if (coinsurance) {
      totalAfter = initialTotal - (parseFloat(deductible) || 0.0);
      setDeductible(0);
    }
    // Round to cents — raw float addition showed 0.1+0.1+0.1 as
    // 0.30000000000000004 in the Total box (QA video 1220736852).
    setTotalAmount((Math.round(totalAfter * 100) / 100).toString());
  }, [copay, selfPay, paymentOnAccount, deductible, coinsurance]);

  const fetchData = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/payments/payment-methods`);
      if (response.status === 200) {
        setPaymentMethod(response.data);
      } else {
        setPaymentMethod([]);
      }
    } catch (error) {
      console.error('Error fetching payment methods:', error);
    }
  };
const fetchprevamount = async () => {
  try {
    const response = await api.post(
      `/v1/${practiseid}/patient/${data.patientid}/appointment/payment-details`,
      {
        appointmentid: data.appointmentid,
        startdate: dayjs().format("YYYY-MM-DD"),
      }
    );
   if (response.status === 200) {
      const payments = response?.data;
  setPrevamount(payments)
    } else {
      setPrevamount([]);
    }
  } catch (error) {
    console.log(error);
    setPrevamount(0);
  }
};
  useEffect(() => {
    if (getpaymentData && activeTab === 'payment') {
      if(flow=='reports'){
 setCopay(currentPatient.copay || 0.0);
      setSelfPay(currentPatient.selfpay || 0.0);
      setDeductible( 0.0);
      setPaymentOnAccount( 0.0);
      }else{
         setCopay(getpaymentData.copay || 0.0);
      setSelfPay(getpaymentData.selfpay || 0.0);
      setDeductible(getpaymentData.deductibleamt || 0.0);
      setPaymentOnAccount(getpaymentData.acctbalance || 0.0);
      // 7825: the visit's coinsurance dollars (percentage.Amount).
      if (osaVisitPayments) setCoinsurance(osaCoinsuranceAmount(getpaymentData));
      }
     


    } else if (activeTab === 'update') {
      setCopay('');
      setSelfPay('');
      setPaymentOnAccount('');
      setCoinsurance('');
      setDeductible('');
      setTotalAmount('0');
    } else if (osaVisitPayments && activeTab === 'payment') {
      // 7825: no row for the visit on screen (yet): an empty form.
      setCopay(0.0);
      setSelfPay(0.0);
      setPaymentOnAccount(0.0);
      setDeductible(0.0);
      setCoinsurance(0.0);
    }
  }, [activeTab, getpaymentData]);

  const handleCcnumberChange = (e) => {
    setCcnumber(e.target.value);
  };

  const resetForm = () => {
    setCopay('');
    setSelfPay('');
    setPaymentOnAccount('');
    setCoinsurance('');
    setDeductible('');
    setTotalAmount(0);
    setCcnumber('');
    setSelectedPaymentMethod(null);
  };

  const handleCloseModal = () => {
    resetForm();
    ClosePaymentModal();
  };

  const handlePaymentMethodChange = (e) => {
    const selectedId = e.target.value;
    const selectedMethod = PaymentMethod.find((payment) => payment.id === parseInt(selectedId));
    setSelectedPaymentMethod(selectedMethod);
    setCcnumber('');
  };

  const handlePaySubmit = async () => {
    switch (true) {
      // At least ONE amount field is enough — requiring all three made a
      // single-field payment show "Invalid Amount" (QA 2026-08-20).
      case !copay && !paymentOnAccount && !selfPay:
        setAlertMessage('Invalid Amount');
        setSeverity('error');
        setOpen(true);
        return;
      case !selectedPaymentMethod:
        setAlertMessage('Please Select Payment Method');
        setSeverity('warning');
        setOpen(true);
        return;
      case !ccnumber&&!selectedPaymentMethod?.method==='CASH':
        setAlertMessage('Please enter last Four Digits');
        setSeverity('error');
        setOpen(true);
        return;
      default:
        break;
    }

    // Untouched inputs hold "" — send numbers so the API's float fields
    // never reject a single-field payment (QA video 1220728642).
    const payload = {
      department_id: 1,
      patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount: parseFloat(totalAmount) || 0,
      paymentmethodid: selectedPaymentMethod.id,
      paymentmethod: selectedPaymentMethod.type,
      ccnumber: ccnumber,
      paymentstatus: 'success',
      paymentlocation: 'Practice App',
      paymenttype: selectedPaymentMethod.type,
      copay: parseFloat(copay) || 0,
      paymentonaccount: parseFloat(paymentOnAccount) || 0,
      insurance: currentPatient.insurancename,
      selfpay: parseFloat(selfPay) || 0,
      createdby: loginUser,
    };

    try {
      const response = await api.post(`/v1/${practiseid}/patient/${currentPatient.patientid}/payments/take-payments`, payload);
      if (response.status === 200) {
      // setAlertMessage('Payment processed successfully.');
      //   setSeverity('success');
      //   setOpen(true);
       dispatch(showToast({
        message: "Payment processed successfully",
        severity: "success"
      }));
          setOpen(false);
          handleCloseModal();
    
      } else {
        setAlertMessage(response.message);
        setSeverity('info');
        setOpen(true);
        // setTimeout(() => {
        //   navigate('/landing');
        // }, 1000);
      }
    } catch (error) {
      // A rejected request used to fail silently — front desk clicked Pay
      // and nothing visibly happened.
      console.error('Error submitting payment:', error);
      setAlertMessage(error?.response?.data?.message || 'Payment failed — please try again');
      setSeverity('error');
      setOpen(true);
    }
  };

  const handleNextPatient = () => {
    if (currentIndex < alldata.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevPatient = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleUpdatePay = async () => {
    if (!copay && !selfPay && !paymentOnAccount) {
      setAlertMessage('Invalid Amount');
      setSeverity('error');
      setOpen(true);
      return;
    }

  
    
    try {
      if(flow=='reports'){
        console.log(currentPatient)

       const selectedMethod = PaymentMethod?.find(
  (method) => method.type === currentPatient?.type
);

        const payload={
           "payment_id":currentPatient.payment_id,
  "patientid": currentPatient.patientid,
  "appointmentid": currentPatient.appointmentid,
  "patientname": currentPatient.patient_name,
  "amount": totalAmount||0,
   "paymentmethodid": selectedMethod?.id || "",
 // "paymentmethod": currentPatient?.type||'',
  "ccnumber":currentPatient?.ccnumber,
  "paymentstatus": currentPatient?.payment_status||'',
  "paymentlocation": currentPatient?.payment_location||'Practice App',
  "paymenttype": currentPatient?.payment_type||"",
  "copay":  copay || 0.0,
  "paymentonaccount":  paymentOnAccount || 0.0,
  // "insurance":  currentPatient.insurance||'',
  "selfpay": selfPay||0,
  "createdby": loginUser,
        }

        const response=await api.post(`/v1/${practiseid}/patient-payments/update`,payload)

            if (response.status === 200) {

                updatedata({
    ...currentPatient,
    copay,
    selfpay: selfPay,
    paymentonaccount: paymentOnAccount,
    amount: totalAmount
  });
           dispatch(showToast({
       message: response.message,
       severity: "success"
     }));
        
          setOpen(false);
          handleCloseModal();
        
      } else {
        setAlertMessage(response.message);
        setSeverity('info');
        setOpen(true);
        // setTimeout(() => {
        //   handleCloseModal();
        // }, 2000);
      }

    }else{
    // 7825: only a form holding this visit's loaded amounts is saved.
    if (osaVisitPayments && !isPaymentRowFor(getpaymentData, currentPatient)) {
      setAlertMessage(PAYMENT_ROW_NOT_LOADED);
      setSeverity('error');
      setOpen(true);
      return;
    }
const formattedStartDate = dayjs(currentPatient.startdate).format('YYYY-MM-DD');

    const payload = {
      patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      location: 'Practice App',
      insurance: currentPatient.insurancename,
      copay: copay || 0.0,
      accountbalance: paymentOnAccount || 0.0,
      deductibleamt: deductible || 0.0,
      coinsurancepercent: coinsurance || 0.0,
      selfpaybalance: selfPay || 0.0,
      amount: totalAmount || 0.0,
      searchdate: formattedStartDate,
      createdby: loginUser,
    };


  // 7825: OSA's v1-only update-patient-payments (this appointment only,
  // coinsurance in dollars). updatepaymentupdate writes every visit the
  // patient has that day and blanks their coinsurance.
  const response = osaVisitPayments
    ? await putOsaPaymentUpdate(practiseid, currentPatient.patientid, payload)
    : await api.put(`/v1/${practiseid}/patient/${currentPatient.patientid}/payments/updatepaymentupdate`, payload);
      if (response.status === 200) {
           dispatch(showToast({
       message: response.message,
       severity: "success"
     }));
        
          setOpen(false);
          handleCloseModal();
        
      } else {
        setAlertMessage(response.message);
        setSeverity('info');
        setOpen(true);
        // setTimeout(() => {
        //   handleCloseModal();
        // }, 2000);
      }

    }
    } catch (error) {
       setAlertMessage('Something went wrong');
        setSeverity('error');
        setOpen(true);
      console.error('Error updating payment:', error);
    }
  };

  const handleStatus = async (selectedColor) => {
    // 7825: no colour options (OSA never sets one).
    if (osaPayments) return;
    const formattedStartDate = dayjs(currentPatient.startdate).format('YYYY-MM-DD');

    const payload = {
      patient_name: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount: selectedColor,
      type: 'dele',
      searchdate: formattedStartDate,
      createdby: loginUser,
    };

    try {
      const response = await api.put(`/v1/${practiseid}/appointments/patient/${currentPatient.patientid}/payment/update`, payload);
      if (response.status === 200) {
        fetchFrontDesk();
  handleGetPayment({data:currentPatient });
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };


 const handleCheckboxChange = (color, tabName) => {
  if (osaPayments) return;

  // if deductible → open modal only
  if (color === 'F3082C'||tabName==="Coinsurance") {
    setSelectedColor(color);
    setSelectedTab(tabName);
    setInsuranceModalOpen(true);
    return; // 🚫 stop API
  }

  // normal flow
  if (selectedColor === color) {
    setSelectedColor('');
    setSelectedTab('');
  } else {
    setSelectedColor(color);
    setSelectedTab(tabName);
  }

  handleStatus(color); // normal colors only
};
useEffect(() => {
  if(flow=='reports'){
        setActiveTab('payment'); 
        return
  }
      if (userConfig?.grole == 2||userConfig?.grole == 3) {
    setActiveTab('update');   // Pay tab
  } else {
    setActiveTab('payment');  // Update tab
  }
}, [userConfig]);

const handleInsuranceSave = async (plans) => {
  setInsuranceModalOpen(false);
  if (osaPayments) return;
  setSelectedPlans(plans || []);

  const formattedStartDate = dayjs(currentPatient.startdate).format('YYYY-MM-DD');

  const payload = {
    patient_name: `${currentPatient.firstname} ${currentPatient.lastname}`,
    appointmentid: currentPatient.appointmentid,
    amount: 'F3082C',
    type: 'dele',
    searchdate: formattedStartDate,
    createdby: loginUser,
  };

  // 🔥 add key ONLY in deductible flow
  payload.insuranceCoveredPlan = plans || [];

  try {
    const response = await api.put(
      `/v1/${practiseid}/appointments/patient/${currentPatient.patientid}/payment/update`,
      payload
    );

    if (response.status === 200) {
      fetchFrontDesk();
      handleGetPayment({ data: currentPatient });
    }
  } catch (err) {
    console.log(err);
  }
};
;

  const handleFrontDeskToggle = () => {
    const newStatus = frontDesk === 'Y' ? 'N' : 'Y';
    setFrontDesk(newStatus);
    fetchUpdateFrontDesk({ frontDesk: newStatus, data:currentPatient });
  };

  const hanldeFrontdeskModal = () => {
    setfrontdeskModal(true);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg lg:w-[35%] w-[80%]">
        <div className="w-full justify-between flex border-b mb-2">
          <div className="flex">
            <h2 className="text-xl font-semibold text-[#09090B]">
              Patient {currentIndex + 1} of {alldata.length}
            </h2>
           
          </div>
          <ClearIcon onClick={()=>{
            setPrevamount('')
            handleCloseModal()}} className="cursor-pointer" />
        </div>
        <div className="flex items-center justify-between py-2">
          <button
            onClick={handlePrevPatient}
            disabled={currentIndex === 0}
            className="bg-[#E5E7EB] text-gray-600 rounded-md w-10 h-10 flex items-center justify-center hover:bg-black hover:text-white active:bg-black disabled:opacity-50"
          >
            <span className="text-xl"><ChevronLeftIcon/></span>
          </button>
          <div className="rounded-[8.75px] border-2 border-[#E4E4E7] bg-[#FAFAFA]  px-6 py-4 text-center">
            <div className="text-lg font-semibold">
              {flow==='reports'?<><span className="font-bold text-[20px] text-[#18181B]">
                {currentPatient.patient_name}
              </span></>:<span className="font-bold text-[20px] text-[#18181B]">
                {currentPatient.firstname} {currentPatient.lastname}
              </span>}
              
              {' '}
              {currentPatient.patientid}
            </div>
            <div className="text-sm text-[#3F3F46] mt-1">{formatDateTime(
  getpaymentData?.startdate,
  currentPatient?.start_time
)}</div>
            <div className="text-sm text-[#52525C] mt-1">{currentPatient.insurancename}</div>
          </div>
          <button
            onClick={handleNextPatient}
            disabled={currentIndex === alldata.length - 1}
            className="bg-black text-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-gray-800 disabled:opacity-50"
          >
            <span className="text-xl"><ChevronRightIcon/></span>
          </button>
        </div>
      {flow=='reports'?<></>:  <div className="flex bg-gray-100 rounded-lg p-2 gap-1">
          <button
            className={`py-2 px-4 text-[14px] font-inter outline-none w-full text-center ${
              activeTab === 'payment' ? 'text-black bg-white border-none' : 'text-gray-400'
            }`}
            onClick={() => setActiveTab('payment')}
          >
           Update
          </button>
          <button
            className={`py-2 px-4 text-[14px] font-inter outline-none w-full text-center ${
              activeTab === 'update' ? 'text-black bg-white border-none' : 'text-gray-400'
            }`}
            onClick={() => setActiveTab('update')}
          >
            Pay
          </button>
        </div>}
        <div className="mt-4">
          {activeTab === 'payment' && (
            <div>
              <div className={`mt-4 relative flex gap-4 justify-center${osaPayments ? ' min-h-[2.5rem]' : ''}`}>
               <div className='absolute left-6 top-2'>
                <div className="mx-2 cursor-pointer" onClick={hanldeFrontdeskModal}>
              {frontDesk === 'N' ? <PersonalVideoIcon /> : <img src={cancelledDesk} className="mt-2" alt="$" />}
            </div>
                </div> 
                {/* 7825: no Covered / Coinsurance / Deductible colour options
                    (the front-desk icon stays). */}
                {!osaPayments && (<>
                <div
                  className={`flex cursor-pointer items-center flex-col  ${
                    selectedColor === '58D68D' ? '' : ''
                  }`}
                  onClick={() => handleCheckboxChange('58D68D', 'Covered')}
                >
                  <input
                    className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-[#58D68D] checked:bg-[#58D68D] ring-2 ring-white"
                    name="updateOption"
                    id="option1"
                    type="checkbox"
                    checked={selectedColor === '58D68D'}
                  />
                  <label className="block text-sm font-medium mb-1 text-[#71717A]">Covered</label>
                </div>
                <div
                  className={`flex cursor-pointer items-center flex-col px-2 `}
                  onClick={() => handleCheckboxChange('F9E79F', 'Coinsurance')}
                >
                  <input
                    className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-[#F59E0B] checked:bg-[#F59E0B] ring-2 ring-white"
                    name="updateOption"
                    id="option2"
                    type="checkbox"
                    checked={selectedColor === 'F9E79F'}
                  />
                  <label className="block text-sm font-medium mb-1 text-[#71717A]">Coinsurance</label>
                </div>
                <div
                  className={`flex cursor-pointer items-center flex-col px-2 ${
                    selectedColor === 'F3082C' ? 'border-[#F43F5E]' : 'border-gray-300'
                  }`}
                  onClick={() => handleCheckboxChange('F3082C', 'Deductible')}
                >
                  <input
                    className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-[#F43F5E] checked:bg-[#F43F5E] ring-2 ring-white"
                    name="updateOption"
                    id="option3"
                    type="checkbox"
                    checked={selectedColor === 'F3082C'}
                  />
                  <label className="block text-sm font-medium mb-1 text-[#71717A]">Deductible</label>
                </div>
                {selectedTab?.length ? (
                  <div onClick={() => handleCheckboxChange('0', '')} className="cursor-pointer">
                    <CloseIcon />
                  </div>
                ) : (
                  <div></div>
                )}
                </>)}
              </div>
              <div className="grid grid-cols-1 gap-4 mt-4">
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-medium font-semibold font-inter mb-1">Co-pay</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={copay}
                      onChange={(e) => setCopay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                        onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">Balance</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={paymentOnAccount}
                      onChange={(e) => setPaymentOnAccount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder="" 
                       onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">Deductible</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                  <input
  value={deductible}
  onChange={(e) => setDeductible(e.target.value)}
  type="number"
  disabled={
   // 7825 (OSA): editable whatever the visit status.
   !osaPayments && !(
      currentPatient?.visit_confirmation === "" ||
      currentPatient?.visit_confirmation === "visit_confirmation" ||
      currentPatient?.visit_confirmation === "Tele - Confirmed"
    )
  }
  className={`w-full border-none outline-none px-1 ${
   !osaPayments && !(
      currentPatient?.visit_confirmation === "" ||
      currentPatient?.visit_confirmation === "visit_confirmation" ||
      currentPatient?.visit_confirmation === "Tele - Confirmed"
    )
      ? "cursor-not-allowed"
      : ""
  }`}
  placeholder=""
  onWheel={(e) => e.target.blur()}
/>
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">Self Pay</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={selfPay}
                      onChange={(e) => setSelfPay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                        onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                {osaVisitPayments && (
                  // 7825 (OSA): coinsurance in dollars, always shown, in the total.
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">Co-Insurance</label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-md font-inter text-gray-500">$</span>
                      <input
                        value={coinsurance}
                        onChange={(e) => setCoinsurance(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        aria-label="Co-Insurance"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                )}
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">Total</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm"></span>
                    <input
                      value={totalAmount}
                      onChange={(e) => setTotalAmount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                        onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                {!osaPayments && selectedTab === 'Coinsurance' && (
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">Co-Insurance</label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-md font-inter text-gray-500">%</span>
                      <input
                        value={coinsurance}
                        onChange={(e) => setCoinsurance(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                          onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                )}
                {/* {getpaymentData?.copay ?<div className="text-sm text-start font-semibold text-[#71717A]">
  Total: ${getpaymentData?.copay }
</div>:<></>} */}
              </div>
              <div className="mt-6 flex flex-col gap-2 text-left">
                <div className="text-sm font-semibold text-[#71717A] mt-1">{currentPatient.insurancename}</div>
                <button onClick={() => handleUpdatePay()} className="w-full py-2 bg-black text-white rounded-lg">
                  Update Payment
                </button>
              </div>
            </div>
          )}
          {activeTab === 'update' && (
            <div>
             {Array.isArray(prevamount) && prevamount.length > 0 ? (
                 <div className="flex justify-center items-center ">
             
             
               <div className="text-center flex items-center font-bold text-[#71717A]">
                 Amount Paid: ${prevamount[0].amount} on{" "}
                 {new Date(prevamount[0].payment_date).toLocaleDateString("en-US", {
                   month: "2-digit",
                   day: "2-digit",
                   year: "numeric",
                 })}
             {prevamount.length > 1 && (
               <FontAwesomeIcon
                 icon={faEye}
                 className="ml-2 text-[#71717A] cursor-pointer"
                 onClick={() => setShowPaymentsHistory(true)}
               />
             )}
               </div>
             
                 </div>
             
             ) : null}
              <div className="text-[17px] font-inter mb-1 text-left">Payment method</div>
              <div className="flex gap-4 justify-between flex-col items-center mt-2 mb-2">
                <select onChange={handlePaymentMethodChange} className="border rounded-lg px-2 py-2 w-[100%]">
                  <option value="">Select Payment method</option>
                  {PaymentMethod.length === 0 ? (
                    <option disabled>No methods available</option>
                  ) : (
                    PaymentMethod.map((payment) => (
                      <option key={payment.id} value={payment.id}>
                        {payment.method}
                      </option>
                    ))
                  )}
                </select>
                {selectedPaymentMethod && !(selectedPaymentMethod.method === 'CASH') && (
                  <div className="w-full">
                    <label className="block mb-1 text-left text-sm">
                      {selectedPaymentMethod.method === 'CHECK' ? 'Check Number' : 'Enter 4 digits'}
                    </label>
                    <input
                      type="text"
                      value={ccnumber}
                      onChange={(e) => setCcnumber(e.target.value)}
                      maxLength="4"
                      pattern="[0-9]{4}"
                      placeholder="4 digits"
                        onWheel={(e) => e.target.blur()}
                      className="w-full border rounded-md px-2 py-1"
                    />
                  </div>
                )}
              </div>
              <p className="text-[16px] font-semibold mb-2 text-left">Payment Type</p>
              <div className="grid grid-cols-1 gap-4 mt-1">
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold font-inter mb-1">Co-pay</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={copay}
                      onChange={(e) => setCopay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                        onWheel={(e) => e.target.blur()}
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold mb-1">Self Pay</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={selfPay}
                      onChange={(e) => setSelfPay(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                        onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold mb-1 w-[134px] text-left">Payment</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={paymentOnAccount}
                      onChange={(e) => setPaymentOnAccount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                        onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between items-center">
                  <label className="block text-sm font-semibold mb-1">Total</label>
                  <div className="flex items-center w-[70%] border rounded-lg px-1">
                    <span className="text-sm">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <input
                      value={totalAmount}
                      onChange={(e) => setTotalAmount(e.target.value)}
                      type="number"
                      className="w-full border-none outline-none px-1"
                      placeholder=""
                        onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 flex flex-col gap-2 text-left">
                <div className="text-sm font-semibold text-[#71717A] mt-1">{currentPatient.insurancename}</div>
                <button onClick={() => handlePaySubmit()} className="w-full py-2 bg-black text-white rounded-lg">
                  Pay
                </button>
              </div>
            </div>
          )}
        </div>
        {frontdeskModal && (
          <ConfirmFrontdesk frontDesk={frontDesk} handleFrontDeskToggle={handleFrontDeskToggle} setfrontdeskModal={setfrontdeskModal} />
        )}
        {insuranceModalOpen && (
  <InsurancePlansModal
    open={insuranceModalOpen}
    preSelected={selectedPlans}
    onClose={() => setInsuranceModalOpen(false)}
    onSave={handleInsuranceSave}
  />
)}
  {showPaymentsHistory && (
  <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 p-3 sm:p-4">
    
    <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">

      {/* Header */}
      <div className="flex justify-between items-center border-b px-3 py-2 sm:px-4 sm:py-3">
        <h3 className="font-semibold text-base sm:text-lg">
          Payment History
        </h3>
        <CloseIcon
          className="cursor-pointer text-gray-600"
          onClick={() => setShowPaymentsHistory(false)}
        />
      </div>

      {/* Payments list */}
      <div className="overflow-y-auto px-3 py-2 sm:px-4 sm:py-3 space-y-2 flex-1">

        {prevamount.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center border rounded-md px-2 py-2 sm:px-3"
          >
            <div className="text-xs sm:text-sm text-gray-600">
              {new Date(item.payment_date).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })}
            </div>

            <div className="font-semibold text-sm sm:text-base text-gray-800">
              ${item.amount}
            </div>
          </div>
        ))}

      </div>

    </div>
  </div>
)}
  <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

        <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handlealert} />
      </div>
    </div>
  );
};

export default Payments;